(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const searchModal = document.getElementById('search-modal');
    if (!searchModal) return;

    const input = searchModal.querySelector('#cmdk-input');
    if (!input) return;

    const updateSearchModalState = () => {
      const hasQuery = input.value.trim().length > 0;
      searchModal.classList.toggle('search-modal--has-query', hasQuery);
    };

    // Initial state
    updateSearchModalState();

    // Update state while typing
    input.addEventListener('input', updateSearchModalState);
    input.addEventListener('change', updateSearchModalState);
    input.addEventListener('search', updateSearchModalState);

    // When modal opens and input is empty, keep results hidden
    input.addEventListener('focus', updateSearchModalState);

    // Optional: when dialog closes, clear state
    const dialog = searchModal.querySelector('dialog');
    if (dialog) {
      dialog.addEventListener('close', () => {
        input.value = '';
        updateSearchModalState();
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
